import React, { useEffect, useRef, useState } from "react";
import { navigate } from "gatsby";

/**
 * Panel de búsqueda a pantalla completa. No busca acá: manda a /busqueda con
 * el término en la query string, que es donde vive el índice de flexsearch.
 */
const SearchPanel = ({ isOpen, onClose }) => {

	const [query, setQuery] = useState("");
	const inputRef = useRef(null);

	useEffect(() => {
		if (isOpen) {
			window.requestAnimationFrame(() => inputRef.current?.focus());
		}
	}, [isOpen]);

	if (!isOpen) return null;

	const handleSubmit = (event) => {
		event.preventDefault();
		const term = query.trim();
		onClose();
		navigate(term ? `/busqueda?q=${encodeURIComponent(term)}` : "/busqueda");
	};

	const handleBackdropClick = (event) => {
		if (event.target === event.currentTarget) onClose();
	};

	return (
		<div
			className="fixed inset-0 z-[100] bg-ink/[.97] text-white backdrop-blur-sm"
			onMouseDown={ handleBackdropClick }
			role="dialog"
			aria-modal="true"
			aria-label="Buscar productos"
		>
			<div className="shell relative flex min-h-full items-start justify-center pt-32 md:items-center md:pt-0">
				<form className="w-full max-w-[840px]" role="search" onSubmit={ handleSubmit }>
					<label htmlFor="site-search" className="mb-5 block text-xs font-bold uppercase tracking-[.14em] text-white/60">
						Buscar productos
					</label>
					<div className="grid grid-cols-1 border-b border-white/40 md:grid-cols-[1fr_auto]">
						<input
							id="site-search"
							ref={ inputRef }
							name="q"
							type="search"
							value={ query }
							onChange={ (event) => setQuery(event.target.value) }
							placeholder="Buscar por producto, código o marca"
							autoComplete="off"
							className="h-[68px] min-w-0 border-0 bg-transparent p-0 text-[clamp(1.15rem,4.2vw,2.4rem)] tracking-[-.04em] text-white outline-none placeholder:text-white/30 md:h-[78px]"
						/>
						<button type="submit" className="mt-4 h-12 w-full self-center border border-white/50 px-[22px] text-white transition-colors duration-200 hover:bg-white hover:text-ink md:mt-0 md:w-auto">
							Buscar
						</button>
					</div>
				</form>

				<button
					type="button"
					onClick={ onClose }
					aria-label="Cerrar búsqueda"
					className="absolute right-0 top-7 h-12 w-12 text-4xl font-extralight text-white"
				>
					×
				</button>
			</div>
		</div>
	);
};

export default SearchPanel;
